import type { TransportOrderIdView, WaybillIdView } from '../../store/models/shipment-id-view.model';
import { ListRange, SearchCriteriaBase } from './list.model';

export interface ShipmentSapDeliveryModel {
  gb: string;
  sapPlantId: string;
  sapSystem: string;
  sapMrpController: string;
  sapMaterialNumber: string;
  sapMaterialDescription: string;
  sapDeliveredQty: number;
  sapPoNumber: string;
  sapDeliveryNumber: string;
  sapDeliveryItem: string;
  sapExternalDeliveryNumber: string;
  invoice: string;
  sapSupplierNumber: string;
  sapSupplierName: string;
}

export class ShipmentSapDeliveryListSearchCriteria extends SearchCriteriaBase {
  transportOrderIdView?: TransportOrderIdView;
  waybillIdView?: WaybillIdView;
  constructor(params?: Partial<ShipmentSapDeliveryListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
